import { session } from '@/utils';
let { host } = window.location;
let inPre = host.indexOf('pre-') === 0;
let isPreApi = session.getItem('preDebug') === 'true';

function preTool() {
  if (inPre) {
    let el = document.createElement('div');
    el.innerText = isPreApi ? '当前环境是Pre环境，点击我切换成正式' : '当前是正式环境，点击我切换Pre环境';
    Object.assign(el.style, {
      padding: '8px',
      background: 'orange',
      color: '#fff',
      position: 'fixed',
      right: '20px',
      bottom: '5px',
      zIndex: '10000',
      cursor: 'pointer',
    });
    el.onclick = function () {
      session.setItem('preDebug', isPreApi ? null : 'true');
      window.location.reload();
    };
    document.body.appendChild(el);
  }
}

export { preTool };
